import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

class ConfirmationButton extends React.Component {
  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleConfirm = () => {
    this.setState({ open: false }, this.props.onConfirm);
  }

  render() {
    const {
      Component,
      children,
      dialogText,
      onConfirm,
      ...other
    } = this.props;

    return (
      <>
        <Component
          {...other}
          onClick={this.handleOpen}
        >
          {children}
        </Component>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText>
              {dialogText || (
                <FormattedMessage
                  id="Are you sure?"
                  defaultMessage="Are you sure?"
                />
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              color="primary"
            >
              <FormattedMessage
                id="Cancel"
                defaultMessage="Cancel"
              />
            </Button>
            <Button
              onClick={this.handleConfirm}
              color="primary"
              autoFocus
            >
              <FormattedMessage
                id="Yes"
                defaultMessage="Yes"
              />
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

ConfirmationButton.propTypes = {
  Component: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  dialogText: PropTypes.node,

  onConfirm: PropTypes.func.isRequired,
};

ConfirmationButton.defaultProps = {
  Component: Button,
};

export default ConfirmationButton;
